import { render, staticRenderFns } from "./tickets-list-item.vue?vue&type=template&id=b5b1d316"
import script from "./tickets-list-item.vue?vue&type=script&lang=js"
export * from "./tickets-list-item.vue?vue&type=script&lang=js"
import style0 from "./tickets-list-item.vue?vue&type=style&index=0&id=b5b1d316&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports